module.exports = __webpack_public_path__ + "media/images/cms/bg_profile-550623fb8542a55e180c6da8ebce27a0.png";